import { useCurrentUser } from 'hooks/selectors';
import { ViewVehicle } from './index';
import { PublicViewVehicle } from '../../Public/PublicViewVehicle';

export const VehicleViewGate = () => {
  const user = useCurrentUser();
  const isAuthenticated = !!user?.role;

  if (isAuthenticated) return <ViewVehicle />;
  return <PublicViewVehicle />;
};
